var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 44.5,
    r: 18,
    stroke: "#D9D9D9",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 89C102.5 94.8454 98.7836 100.208 92.6264 104.135C86.4749 108.057 77.9463 110.5 68.5 110.5C59.0537 110.5 50.5251 108.057 44.3736 104.135C38.2164 100.208 34.5 94.8454 34.5 89C34.5 83.1546 38.2164 77.7916 44.3736 73.8652C50.5251 69.9426 59.0537 67.5 68.5 67.5C77.9463 67.5 86.4749 69.9426 92.6264 73.8652C98.7836 77.7916 102.5 83.1546 102.5 89Z",
    stroke: "#D9D9D9",
    strokeOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 68.5,
    stroke: "#D9D9D9",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2fab4742638acb43a4a54c3f8aea2fa0.svg";
export { ForwardRef as ReactComponent };